import { render, staticRenderFns } from "./SideJob.vue?vue&type=template&id=3b8130fc&scoped=true&"
import script from "./SideJob.vue?vue&type=script&lang=js&"
export * from "./SideJob.vue?vue&type=script&lang=js&"
import style0 from "./SideJob.vue?vue&type=style&index=0&id=3b8130fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8130fc",
  null
  
)

export default component.exports